
import Reservation from '@/classes/Booking/deprecated.Reservation.class';
import { createStore } from 'vuex'
import { auth } from './auth.module';
import { auth_admin } from './auth-admin.module';

import moment from 'moment';

export default createStore({
  modules: {
    auth,
    auth_admin
  },
  state: {

    module: {},
    billetterie: false,
    parcours_billetterie: false,
    overlay: false,
    preselection: {},
    inscription_groupe: false,
    admin_view: false,
    admin_ins: false,
  },
  getters: {
    getReservation(state) {
      return state.reservation;
    }
  },
  mutations: {
    setReservation(state, reservation) {
      state.reservation = reservation;
    },
    clearReservation(state, reservation) {
      state.reservation = reservation;
      if (localStorage.getItem('store')) {
        localStorage.removeItem('store');
      }
    },
    initialiseStore(state) {
      // Check if the ID exists
      if (localStorage.getItem('store_sportips')) {
        // Replace the state object with the stored item
        if (localStorage.getItem('store_sportips_expires') && moment().isBefore(localStorage.getItem('store_sportips_expires'))) {
          let store = JSON.parse(localStorage.getItem('store_sportips'));

          let reservation = new Reservation();
          if (store.reservation) {
            reservation.set(store.reservation);
          }
          reservation.compute_cart();
          state.reservation = reservation;
        }
        else {
          localStorage.removeItem('store_sportips');
          localStorage.removeItem('store_sportips_expires');
        }
      }

    },


  },
  actions: {
  },

})
